"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var createConnect_1 = require("./createConnect");
exports.default = createConnect_1.default({
    field: 'meta',
    mapProps: function (meta) { return ({
        pages: meta && immutable_1.Range(1, Math.ceil(meta.get('total') / meta.get('limit'))),
        current: meta && Math.ceil(meta.get('offset') / meta.get('limit')) + 1
    }); },
    handlers: {
        getPageProps: function (_a) {
            var update = _a.update, meta = _a.meta;
            return function (page) { return ({
                key: page,
                onClick: function (e) {
                    if (e)
                        e.preventDefault();
                    update('offset', (page - 1) * meta.get('limit'));
                }
            }); };
        }
    }
});
//# sourceMappingURL=connectPagination.js.map